function renderColumnsLayoutTemplate({ actions }: { actions: string }): string {
  return `  {
    id: 'actions',
    size: 64,
    enableResizing: false,
    meta: { width: '64px' },
    header: () => <span className="sr-only">Actions</span>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <${actions} id={row.original.id} />
      </div>
    )
  }`
}

function renderColumnsClientModuleTemplate({
  lucideIconsLucide,
  needsImageRendererImage,
  join,
  joinText,
  singular,
  actionImportPath,
  joinContent,
  hasDeleteActions,
  firstColDef,
  restColDefsContent,
  actionsColumnContent
}: {
  lucideIconsLucide: string
  needsImageRendererImage: string
  join: string
  joinText: string
  singular: string
  actionImportPath: string
  joinContent: string
  hasDeleteActions: string
  firstColDef: string
  restColDefsContent: string
  actionsColumnContent: string
}): string {
  return `'use client'

import type { ColumnDef } from '@tanstack/react-table'
${lucideIconsLucide}
${needsImageRendererImage}
${join}
${joinText}
import type { ${singular} } from '@admin/actions/${actionImportPath}'
${joinContent}
${hasDeleteActions}
export const columns: ColumnDef<${singular}>[] = [
${firstColDef}${restColDefsContent}${actionsColumnContent}
]
`
}

export function renderColumnsRenderer(
  request:
    | { kind: 'renderColumnsLayoutTemplate'; props: { actions: string } }
    | {
        kind: 'renderColumnsClientModuleTemplate'
        props: {
          lucideIconsLucide: string
          needsImageRendererImage: string
          join: string
          joinText: string
          singular: string
          actionImportPath: string
          joinContent: string
          hasDeleteActions: string
          firstColDef: string
          restColDefsContent: string
          actionsColumnContent: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderColumnsLayoutTemplate':
      return renderColumnsLayoutTemplate(request.props)
    case 'renderColumnsClientModuleTemplate':
      return renderColumnsClientModuleTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
